
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/bluebonnet-intervention-activities-tier-2-tier-3",
      function () {
        return require("private-next-pages/c/blog-posts/bluebonnet-intervention-activities-tier-2-tier-3.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/bluebonnet-intervention-activities-tier-2-tier-3"])
      });
    }
  